module.exports = __webpack_public_path__ + "static/media/background-hero.8d97c406.svg";